class addOns extends HTMLElement {
    constructor() {
        super();
        this.openPopupButtons = this.querySelectorAll('.js-open-popup');
        this.closePopupButtons = this.querySelectorAll('.js-close-popup');
        this.radioChecks = this.querySelectorAll('.js-radio');
        this.productQuantitys = this.querySelectorAll('.js-quantity');
        this.formData = {'items': []};
        this.init();
    }
  
    init() {
        this.style.display = 'none';
        window.addEventListener('customily-preview-load-finished', function (e) {
            this.style.display = 'block';
        }.bind(this));

        this.openPopupButtons.forEach(function(openPopupButton) {
            openPopupButton.addEventListener('click', this.initOpen.bind(openPopupButton));
        }.bind(this));

        this.closePopupButtons.forEach(function(closePopupButton) {
            closePopupButton.addEventListener('click', this.initClose.bind(closePopupButton));
        }.bind(this));

        this.radioChecks.forEach(function(radioCheck) {
            let valueInput = radioCheck.querySelector('input').value;
            let quantity = radioCheck.closest('.add-ons__controller').querySelector('.product-quantity');
            if (radioCheck.classList.contains('default')) {
                radioCheck.querySelector('input').checked = true;
                radioCheck.querySelector('label').click();
            }
            radioCheck.addEventListener('click', this.initRadioCheck.bind(this, radioCheck));
        }.bind(this));

        this.productQuantitys.forEach(function(productQuantity) {
            productQuantity.addEventListener('change', this.initUpdateQuantity.bind(this, productQuantity));
        }.bind(this));
    }
  
    initOpen() {
        let cross_selling_item = this.parentElement.parentElement;
        let cross_selling_item_preview = cross_selling_item.querySelector('.add-ons__preview-product')
        cross_selling_item_preview.classList.add('active');
        document.body.classList.add('overflow-hidden');
        document.querySelector('main').classList.add('opening-add-ons-modal');
        document.querySelector('.container__top-part').classList.add('opening-add-ons-modal');
    }
  
    initClose() {
        let cross_selling_item_preview = this.parentElement.parentElement;
        if (this.classList.contains('add-ons__modal-background')) {
            cross_selling_item_preview = this.parentElement;
            cross_selling_item_preview.classList.remove('active');
        } else {
            cross_selling_item_preview = this.closest('.add-ons__preview-product');
            cross_selling_item_preview.classList.remove('active');
        }
        document.body.classList.remove('overflow-hidden');
        document.querySelector('main').classList.remove('opening-add-ons-modal');
        document.querySelector('.container__top-part').classList.remove('opening-add-ons-modal');
    }

    initRadioCheck($this) {
        let controller = $this.parentElement.parentElement;
        let quantity = controller.querySelector('.product-quantity');
        let quantityValue = 0;
        let valueInput = $this.querySelector('input').value
        if (valueInput != '') {
            quantity.style.display = 'block';
            quantityValue = Number(quantity.querySelector('select').value);
            const result = this.formData.items.find(({ id }) => id === valueInput);
            if (result === undefined) {
                this.formData.items.push({'id': Number(valueInput), 'quantity': quantityValue});
            }
        } else {
            quantity.style.display = 'none';
            this.formData.items.splice(this.formData.items.findIndex(a => a.id === valueInput) , 1)
        }
    }

    initUpdateQuantity($this) {
        let quantity = Number($this.value);
        let variantId = Number($this.dataset.variantId);
        this.formData.items.find(function(entry) {
            if (entry.id === variantId) {
              entry.quantity = quantity;
            }
        });
    }

    formSubmit() {
        return this.formData.items;
    }
}
  
customElements.define('add-ons', addOns);